export default __webpack_public_path__ + "static/media/RS.711db693.svg";